module.exports = __webpack_public_path__ + "img/kc-empty-icon.a961aa3b.jpg";